import React from 'react';
import StaticNotification from '../../../common/StaticNotification/StaticNotification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';

function ScheduleItemSelectionStaticNotification(props) {
    const {  session } = props,
        i18n = useI18n(),
        { is_selected, is_selectable } = session;

    if (!is_selected || !is_selectable) return null;

    return (
        <StaticNotification className="success" icon={<FontAwesomeIcon icon={faCheck} />}>
            {i18n['label.session_selected']}
        </StaticNotification>
    );
}

export default ScheduleItemSelectionStaticNotification;
